// Live site: keep the browser console quiet so login keys and personal data are never printed.
// Warnings and errors still show.
if (process.env.NODE_ENV === 'production') {
  ['log', 'debug', 'info'].forEach((k) => {
    console[k] = () => {};
  });
}
